/**
 * 密码加密工具 - 使用 RSA 公钥加密
 * 后端需实现对应的解密逻辑，参见 docs/BACKEND_PASSWORD_DECRYPT.md
 */
import JSEncrypt from 'jsencrypt'

/**
 * 使用 RSA 公钥加密密码
 * @param {string} password - 明文密码
 * @param {string} publicKey - PEM 格式的 RSA 公钥
 * @returns {string|null} Base64 编码的密文，加密失败返回 null
 */
export function encryptPassword(password, publicKey) {
  if (!password || !publicKey) return null
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  return encrypt.encrypt(password)
}



// WEBPACK FOOTER //
// ./src/utils/passwordEncrypt.js